export enum AccountRoles {
  Carrier = 'carrier',
  Shipper = 'shipper',
  CustomerService = 'customer_service'
}

export enum ShipperType {
  BCO,
  NVO
}

export enum CarrierType {
  Pricing = 'Pricing',
  Operation = 'Operation',
  BrowsingOnly = 'BrowsingOnly'
}
